import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'

import Back1 from 'assets/images/roadmap/balloon1.png'
import Back2 from 'assets/images/roadmap/balloon2.png'
import Back3 from 'assets/images/roadmap/balloon3.png'
import Back4 from 'assets/images/roadmap/balloon4.png'
import Back5 from 'assets/images/roadmap/balloon5.png'
import Back6 from 'assets/images/roadmap/balloon6.png'
import Check from 'assets/images/roadmap/check.png'
import Snow from 'assets/images/roadmap/snow.png'
import OlafImg from 'assets/images/roadmap/olaf.png'
import SvenImg from 'assets/images/roadmap/sven.png'
import useWindowDimensions from 'hooks/useDimensions'

interface Props {
    mainRef: any
}

const Roadmap: React.FC<Props> = ({ mainRef }) => {
    const screenWidth = useWindowDimensions().width
    const [isMobile, setIsMobile] = useState(false)
    const [isMobile1, setIsMobile1] = useState(false)

    useEffect(() => {
        screenWidth > 1100 ? setIsMobile(false) : setIsMobile(true)
        screenWidth > 1439 ? setIsMobile1(false) : setIsMobile1(true)
    }, [screenWidth])
    return (
        <StyledContainer {...{ ref: mainRef }}>
            <PinkText>Roadmap</PinkText>
            <Text>The road map about  OLAF Token </Text>
            <Balloon1>
                <Box position='relative' height='100%'>
                    <Box position='absolute'>
                        <DateText>2021. Q3</DateText>
                        <ul>
                            <li>Project Plan</li>
                            <li>Fundraising</li>
                            <li>Team organising</li>
                        </ul>
                    </Box>
                    {!isMobile1 ?
                        <>
                            <Box position='absolute' bottom='5%' left='10%' width='29px' height='29px' bgcolor='rgba(186, 206, 255, 0.7)' boxShadow='0px 2px 15px rgba(23, 58, 86, 0.1)' borderRadius='50%' />
                            <Box position='absolute' bottom='-6%' left='17%' width='16px' height='16px' bgcolor='rgba(186, 206, 255, 0.7)' boxShadow='0px 2px 15px rgba(23, 58, 86, 0.1)' borderRadius='50%' />
                            <Box position='absolute' bottom='-19%' left='21%' width='12px' height='12px' bgcolor='rgba(186, 206, 255, 0.7)' boxShadow='0px 2px 15px rgba(23, 58, 86, 0.1)' borderRadius='50%' />
                        </>
                        :
                        <>
                            <Box position='absolute' bottom='-12%' right='3%' width='29px' height='29px' bgcolor='rgba(186, 206, 255, 0.7)' boxShadow='0px 2px 15px rgba(23, 58, 86, 0.1)' borderRadius='50%' />
                            <Box position='absolute' bottom='-22%' right='10%' width='16px' height='16px' bgcolor='rgba(186, 206, 255, 0.7)' boxShadow='0px 2px 15px rgba(23, 58, 86, 0.1)' borderRadius='50%' />
                            <Box position='absolute' bottom='-32%' right='14%' width='12px' height='12px' bgcolor='rgba(186, 206, 255, 0.7)' boxShadow='0px 2px 15px rgba(23, 58, 86, 0.1)' borderRadius='50%' />
                        </>
                    }
                </Box>
            </Balloon1>
            <Balloon2>
                <Box position='relative' height='100%'>
                    <Box position='absolute'>
                        <DateText>2021. Q4</DateText>
                        <ul>
                            <li>Website Launch</li>
                        </ul>
                        <ul>
                            <li>OLAF Token Presale</li>
                            <li>OLAF Token Launch</li>
                            <li>Pancakeswap Listing</li>
                            <li>OLAF Farming & Pools</li>
                            <li>Airdrop at Christmas</li>
                        </ul>
                    </Box>
                    {!isMobile1 ?
                        <>
                            <Box position='absolute' bottom='17%' left='-14%' width='24px' height='24px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='10%' left='-20%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='3%' left='-26%' width='8px' height='8px' bgcolor='white' borderRadius='50%' />
                        </>
                        :
                        <>
                            <Box position='absolute' bottom='-5%' left='-5%' width='24px' height='24px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='-11%' left='5%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='-15%' left='15%' width='8px' height='8px' bgcolor='white' borderRadius='50%' />
                        </>
                    }
                </Box>
            </Balloon2>
            <Balloon3>
                <Box position='relative' height='100%'>
                    <Box position='absolute'>
                        <DateText>2022. Q1</DateText>
                        <ul>
                            <li>List on coinmarketcap and coingecko</li>
                            <li>Publish 3D Frozen Models</li>
                            <li>3D NFT Sale</li>
                            <li>Launch NFT Marketplace</li>
                        </ul>
                    </Box>
                    {!isMobile1 ?
                        <>
                            <Box position='absolute' top='15%' left='-1%' width='24.47px' height='24.08px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' top='10%' left='-5%' width='13.26px' height='13.04px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' top='13%' left='-11%' width='12.24px' height='12.04px' bgcolor='white' borderRadius='50%' />
                        </>
                        :
                        <>
                            <Box position='absolute' bottom='4%' right='3%' width='12px' height='12px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='-6%' right='3%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='-16%' right='8%' width='24.47px' height='24.08px' bgcolor='white' borderRadius='50%' />
                        </>
                    }
                </Box>
            </Balloon3>
            <Balloon4>
                <Box position='relative' height='100%'>
                    <Box position='absolute'>
                        <DateText>2022. Q2</DateText>
                        <ul>
                            <li>Launch OLAF Vaults</li>
                            <li>Launch SVEN Token</li>
                            <li>SVEN Farming & Pools</li>
                            <li>3D Items Sale</li>
                            <li>3D Battle Game</li>
                            <li>Development</li>
                        </ul>
                    </Box>
                </Box>
                {!isMobile1 ?
                    <>
                        <Box position='absolute' top='-11%' left='41%' width='24.47px' height='24.08px' bgcolor='white' borderRadius='50%' />
                        <Box position='absolute' top='-14%' left='30%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                        <Box position='absolute' top='-14%' left='25%' width='8px' height='8px' bgcolor='white' borderRadius='50%' />
                    </>
                    :
                    <>
                        <Box position='absolute' bottom='5%' left='8%' width='8px' height='8px' bgcolor='white' borderRadius='50%' />
                        <Box position='absolute' bottom='-3%' left='14%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                        <Box position='absolute' bottom='-13%' left='23%' width='24px' height='24px' bgcolor='white' borderRadius='50%' />
                    </>
                }
            </Balloon4>
            <Balloon5>
                <Box position='relative' height='100%'>
                    <Box position='absolute'>
                        <DateText>2022. Q3</DateText>
                        <ul>
                            <li>Publish 3D NFT Game</li>
                            <li>Launch another model<br/>tokens.</li>
                            <li>Hero and Item Merge</li>
                            <li>Launch 3D Battle Game</li>
                        </ul>
                    </Box>
                </Box>
                <Box position='absolute' top='-3%' right='25%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                <Box position='absolute' top='19%' right='-10%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
            </Balloon5>
            <Balloon6>
                <Box position='relative' height='100%'>
                    <Box position='absolute'>
                        <DateText>2021. Q4</DateText>
                        <ul>
                            <li>Launch Lottery</li>
                            <li>Lottery on Game</li>
                            <li>Launch on ETH network</li>
                            <li>Tokens/NFT Bridge<br />
                                {`(BSC <-> ETH)`}</li>
                        </ul>
                    </Box>
                    {!isMobile1 ?
                        <>
                            <Box position='absolute' bottom='10%' right='-5%' width='24px' height='24px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='5%' right='-12%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' bottom='-5%' right='-12%' width='12px' height='12px' bgcolor='white' borderRadius='50%' />
                        </>
                        :
                        <>
                            <Box position='absolute' top='10%' right='10%' width='24px' height='24px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' top='2%' right='2%' width='13px' height='13px' bgcolor='white' borderRadius='50%' />
                            <Box position='absolute' top='-5%' right='2%' width='12px' height='12px' bgcolor='white' borderRadius='50%' />
                        </>
                    }
                </Box>
            </Balloon6>
            <Olaf>
                <img src={OlafImg} alt='' />
            </Olaf>
            <Sven>
                <img src={SvenImg} alt='' />
            </Sven>
            {isMobile && <OlafText>Characters Cards</OlafText>}
        </StyledContainer>
    )
}

const OlafText = styled(Box)`
    font-weight: bold;
    font-size: 36px;
    line-height: 109%;
    text-align: center;
    color: #3F78BD;
    @media (max-width: 1439px) {
        margin-top: 44px;
    }
    @media (max-width: 390px) {
        padding-left: 59px;
        padding-right: 55px;
    }
    @media (max-width: 360px) {
        padding-left: 50px;
        padding-right: 34px;
    }
`

const Olaf = styled(Box)`
    position: absolute;
    bottom: 0;
    left: 0;
    >img {
        height: 100%;
    }
    @media (max-width: 1439px) {
        height: 323px;
        top: 11.7%;
        left: -46px;
    }
`

const Sven = styled(Box)`
    position: absolute;
    bottom: 0;
    right: 0;
    >img {
        height: 100%;
    }
    @media (max-width: 1439px) {
        transform: rotate(-24.25deg);
        height: 403.93px;
        bottom: 28%;
        right: -119px;
    }
    @media (max-width: 360px) {
        bottom: 28%;
        right: -143px;
    }
`

const Balloon6 = styled(Box)`
    width: 315.93px; height: 235.61px;
    position: absolute;
    top: 15%;
    left: 13.5%;
    @media (max-width: 1439px) {
        width: 307px; height: 266.27px;
        position: initial;
        top: 0; left: 0;
        margin: 0;
        margin-left: auto;
        margin-right: auto;
    }
    background-image: url(${Back6});
    background-size: 100% 100%;
    >div >div:first-of-type {
        top: 16%;
        left: 25%;
        >ul {
            margin: 0;
            margin-top: 4px;
            list-style-image: url(${Snow});
            >li {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #000000;
                margin: 0;
                padding: 0;
            }
        }
    }
`

const Balloon5 = styled(Box)`
    width: 327.62px; height: 273.58px;
    position: absolute;
    bottom: 22%;
    left: 17%;
    background-image: url(${Back5});
    background-size: 100% 100%;
    @media (max-width: 1439px) {
        width: 307px; height: 266.27px;
        position: initial;
        top: 0; left: 0;
        margin: 0;
        margin-left: auto;
        margin-right: auto;
        margin-top: 200px;
    }
    @media (max-width: 390px) {
        margin-left: 63px;
        margin-right: 20px;
    }
    @media (max-width: 360px) {
        margin-left: auto;
        margin-right: auto;
    }
    >div >div:first-of-type {
        top: 17%;
        left: 25%;
        >div {
            margin-left: -25px;
        }
        >ul {
            margin: 0;
            margin-top: 4px;
            list-style-image: url(${Snow});
            >li {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #000000;
                margin: 0;
                padding: 0;
            }
        }
    }
`

const Balloon4 = styled(Box)`
    width: 307px; height: 266.27px;
    position: absolute;
    bottom: 14%;
    left: 45%;
    @media (max-width: 1439px) {
        width: 307px; height: 266.27px;
        position: relative;
        top: 0; left: 0;
        z-index: 1;
        margin: 0;
        margin-left: auto;
        margin-right: auto;
        margin-top: 35px;
    }
    @media (max-width: 390px) {
        margin-left: 40px;
        margin-right: 20px;
    }
    @media (max-width: 360px) {
        margin-left: 40px;
        margin-right: 10px;
    }
    background-image: url(${Back4});
    background-size: 100% 100%;
    >div >div:first-of-type {
        top: 16%;
        left: 25%;
        >ul {
            margin: 0;
            margin-top: 4px;
            list-style-image: url(${Snow});
            >li {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #000000;
                margin: 0;
                padding: 0;
            }
        }
    }
`

const Balloon3 = styled(Box)`
    z-index: 1;
    width: 414.72px; height: 227.81px;
    position: absolute;
    top: 44%;
    right: 4%;
    @media (max-width: 1439px) {
        width: 328.34px; height: 266.67px;
        position: initial;
        top: 0; left: 0;
        margin: 0;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
    }
    @media (max-width: 390px) {
        margin-left: 20px;
        margin-right: 30px;
    }
    @media (max-width: 360px) {
        margin-left: 20px;
        margin-right: 20px;
    }
    background-image: url(${Back3});
    background-size: 100% 100%;
    >div >div:first-of-type {
        top: 18%;
        left: 19%;
        >ul {
            margin: 0;
            margin-top: 4px;
            list-style-image: url(${Snow});
            >li {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #000000;
                margin: 0;
                padding: 0;
            }
        }
    }
`

const Balloon2 = styled(Box)`
    width: 324.95px; height: 276.71px;
    position: absolute;
    top: 12%;
    right: 10%;
    @media (max-width: 1439px) {
        position: relative;
        top: 0; left: 0;
        margin: 0;
        z-index: 1;
        margin-left: auto;
        margin-right: auto;
        margin-top: 80px;
    }
    @media (max-width: 390px) {
        margin-left: 47px;
        margin-right: 32px;
    }
    @media (max-width: 360px) {
        margin-left: 20px;
        margin-right: 20px;
    }
    background-image: url(${Back2});
    background-size: 100% 100%;
    >div >div:first-of-type {
        top: 15%;
        left: 23%;
        >ul:first-of-type {
            list-style-image: url(${Check});
        }
        >ul:nth-of-type(2) {
            list-style-image: url(${Snow});
        }
        >ul {
            margin: 0;
            margin-top: 4px;
            >li {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #000000;
                margin: 0;
                padding: 0;
            }
        }
    }
`

const Balloon1 = styled(Box)`
    width: 311px; height: 191px;
    position: absolute;
    top: 8%;
    left: 43%;
    @media (max-width: 1439px) {
        position: initial;
        top: 0; left: 0;
        margin: 0;
        margin-left: auto;
        margin-right: auto;
    }
    @media (max-width: 390px) {
        margin-left: 47px;
        margin-right: 32px;
    }
    @media (max-width: 360px) {
        margin-left: 38px;
        margin-right: 11px;
    }
    background-image: url(${Back1});
    background-size: 100% 100%;
    >div >div:first-of-type {
        top: 15%;
        left: 32%;
        >ul {
            margin: 0;
            margin-top: 4px;
            list-style-image: url(${Check});
            >li {
                font-size: 16px;
                line-height: 24px;
                font-weight: 500;
                color: #000000;
                margin: 0;
                padding: 0;
            }
        }
    }
`

const DateText = styled(Box)`
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #3F78BD;
`

const Text = styled(Box)`
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    color: #4F4F4F;
    margin-top: 11px;
    @media (max-width: 1439px) {
        margin-top: 17px;
        margin-bottom: 33px;
        font-size: 20px;
        line-height: 26px;
        text-align: center;
        color: #000000;
    }
`

const PinkText = styled(Box)`
    font-weight: 900;
    font-size: 48px;
    line-height: 109%;
    @media (max-width: 1439px) {
        font-size: 36px;
    }
    color: #FB6EA4;
    text-align: center;
`

const StyledContainer = styled(Box)`
    overflow: hidden;
    position: relative;
    padding-top: 394px;
    padding-bottom: 524px;
    @media (max-width: 1439px) {
        padding-top: 47px;
        padding-bottom: 48px;
    }
    background-image: linear-gradient(90deg, #bfd9ee 0%, #eaf3f9 50%, #bfd9ee 100%);
`

export default Roadmap